import { BaseProps } from '../../common/BaseProps';
import styles from './BotaoConsulta.module.css';

interface Props extends BaseProps {
  iconClass?: string | null;
  largeIcon?: boolean;
  img?: string | null;
  imgClass?: any;
  text?: string | null;
  outsideText?: boolean;
  alt?: string;
  onClick?: () => void;
}

const BotaoConsulta: React.FC<Props> = (props) => {
  const { onClick, iconClass, largeIcon, img, imgClass, text, alt, outsideText = false } = props;

  return (
    <div className="flex-column flex-align-center" onClick={onClick}>
      <div className={`${styles.card} ${props.className ? props.className : ''}`}>
        {iconClass && (
          <div className={largeIcon ? styles.largeIcon : ''}>
            <i className={`fa ${iconClass} ${styles.icon}`} />
          </div>
        )}
        {img && (
          <div className={`${imgClass ? styles.squareImg : ''} ${text ? styles.imgWithText : ''}`}>
            <img
              className={`${imgClass ? imgClass : styles.img}`}
              src={img}
              alt={alt ?? 'Ícone botão de consulta'}
              onError={(e) => {
                const imgEl = e.currentTarget as HTMLImageElement;
                imgEl.style.display = 'none';
                const fallback = document.createElement('div');
                fallback.textContent = alt ?? 'Imagem não disponível';
                fallback.className = styles.imgAltFallback;
                imgEl.parentElement?.appendChild(fallback);
              }}
            />

          </div>
        )}
        {!outsideText && text && (
          <div className={`${styles.text} ${largeIcon ? styles.largeText : ''}`}>
            <span>{text}</span>
          </div>
        )}
      </div>
      {outsideText && text && <div className={`${styles.text} ${styles.outsideText}`}>{text}</div>}
    </div>
  );
};

export default BotaoConsulta;
